import { useStaticQuery, graphql } from 'gatsby';

const useHomepageStructuredDataQuery = () => {
  const query = useStaticQuery(graphql`
    query HomepageStructuredDataQuery {
      wp {
        sitewideSettings {
          optionsSitewideSettings {
            homepageStructuredData
          }
        }
      }
    }
  `);

  return query;
};

export default useHomepageStructuredDataQuery;
